// skipcq: JS-W1028, JS-0128
import React from 'react';
import { Box, Button, Container, CircularProgress } from '@mui/material';
import Alert from '@mui/material/Alert';
import MetricsTable from './MetricsTable';

function MetricDefinitionsToolbar({ loading, onOpenAdd }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 2,
        mb: 2,
        width: '100%',
      }}
    >
      <Button
        variant="contained"
        onClick={onOpenAdd}
        sx={{ ml: 'auto' }}
        disabled={loading}
      >
        Add metric
      </Button>
    </Box>
  );
}

/**
 * Metric definitions tab: add action and definitions list or loading state.
 */
function MetricDefinitionsTab({
  loading,
  error,
  onOpenAdd,
  metrics,
  emptyMessage,
  imageUrlByName,
  onEdit,
}) {
  const tableSection = loading ? (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        py: 4,
      }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <>
      {error ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      ) : null}
      <MetricsTable
        metrics={metrics}
        emptyMessage={emptyMessage}
        imageUrlByName={imageUrlByName}
        onEdit={onEdit}
      />
    </>
  );

  return (
    <Container maxWidth="lg" sx={{ mt: 2, mb: 4 }}>
      <MetricDefinitionsToolbar loading={loading} onOpenAdd={onOpenAdd} />
      {tableSection}
    </Container>
  );
}

export default MetricDefinitionsTab;
